/*
 * @Author: handan05
 * @Date: 2022-07-28 11:21:05
 * @LastEditors: handan05 handan05@58.com
 * @LastEditTime: 2023-11-06 20:17:29
 * @FilePath: /zcm_step_nodeserver/Users/handan/Documents/handan_work/58work/58project/tech/wblog/src/platforms/wuba.ts
 * @Description:
 */
import { getAppVersion, compareVersion } from '../../helpers';
import { ReportParams } from '../types';
import { processReportParams } from '../utils/processAppParams';

function checkVersion(version: string) {
    var appVersion = getAppVersion(); // 假定为: 7.4.1
    // 1：大于传入版本，0: 等于，-1: 小于
    return compareVersion(appVersion, version);
}

/**
 * 触发埋点
 * @param {
 *  pageType: string
 *  actionType: string
 *  extJson: object
 *  options: object
 * } reportParams
 */
function log(reportParams: ReportParams) {
    const { opt } = processReportParams(reportParams);

    if (!opt) return;

    const hostApp = (<any>window).WBAPP || (<any>window).ZPAPP;

    !hostApp && console.error('【zp-weblog】无线埋点上报异常：hybrid SDK没有加载！');

    const actionName = checkVersion('10.24.0') >= 0 ? 'job_weblog' : 'weblog';
    hostApp && hostApp.invoke(actionName, opt);
}

export default log;
